import { RouteConfig } from '@dfl/react-security';
import { lazy } from 'react';
import InvitationApp from './InvitationApp';
import { EmailVerify, MfaEnrollment } from 'modules/authentication/pages';

const loadMainApp = () => import('routes/MainApp');
export const MainApp = lazy(loadMainApp);

const loadAuthApp = () => import('routes/AuthApp');
export const AuthApp = lazy(loadAuthApp);

export const routes: RouteConfig = {
  EmailVerify: {
    path: '/auth/email-verify/:key',
    component: EmailVerify,
  },
  InvitationLayout: {
    path: '/invitation/accept/:key',
    component: InvitationApp,
    exact: true,
  },
  Auth: {
    path: '/auth/*',
    onlyAnonymous: true,
    component: AuthApp,
  },
  MfaEnrollment: {
    path: '/mfa-setup',
    authenticated: true,
    redirect: '/auth/login',
    component: MfaEnrollment,
  },
  MainLayout: {
    path: '*',
    authenticated: true,
    redirect: '/auth/login',
    component: MainApp,
  },
};
